import { shallowEqual, useSelector } from 'react-redux';
import { useBlocker } from 'react-router-dom';

import {
  ROUTE_PAY_AND_POST,
  ROUTE_PAY_AND_POST_V2,
} from 'src/app/shared/constants/routes';
import {
  FEATURE_NEW_PAY_AND_POST_PAGE,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import type { AppState } from 'src/types/appState';

export const useRedirectToPayAndPostV2 = () => {
  const { draftId } = useSelector(
    (state: AppState) => ({
      draftId: state.session.draftId,
    }),
    shallowEqual,
  );
  const { goToRoute } = useLocalisedRoutes();
  const payAndPostPageV2Feature = useFeatureToggleData(
    FEATURE_NEW_PAY_AND_POST_PAGE,
  );

  /* 
  useBlocker has been used to redirect hirers from PayAndPost page v1 
  to v2 as the routing for react is now declarative and all routes need
  to be defined before any page is rendered. Hence routes could not be
  conditionally rendered based on feature toggle up front
   */
  useBlocker(({ nextLocation }) => {
    if (
      nextLocation.pathname.endsWith(ROUTE_PAY_AND_POST) &&
      Boolean(payAndPostPageV2Feature)
    ) {
      goToRoute(`${ROUTE_PAY_AND_POST_V2}?draftid=${draftId}`);
      return true;
    }
    return false;
  });
};
